export const MAX_GEOCODE_QUERY_LENGTH = 200;

export function isGeocodeQueryTooLong(query: string): boolean {
  return query.trim().length > MAX_GEOCODE_QUERY_LENGTH;
}
